import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { CommerceConfState } from '../models/commerceConfModel';

const initialState: CommerceConfState = {
  commerceConf: null,
};

const commerceConfSlice = createSlice({
  name: 'commerceConf',
  initialState,
  reducers: {
    setCommerceConf: (state, action: PayloadAction<CommerceConfState>) => {
      state.commerceConf = action.payload.commerceConf;
    },
  },
});

export const { setCommerceConf } = commerceConfSlice.actions;
export default commerceConfSlice.reducer;
